import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { HogaRequest } from '../../../domain/hoga.model';
import { GenericService } from './generic.service';
import { UtilsService } from './utils.service';


@Injectable()
export class HogaService extends GenericService {
    constructor(private store: Store,
                private http: HttpClient) {
        super(store);
    }

    search(request: HogaRequest) {
        const params = UtilsService.buildQueryParams(request);
        return this.http.get<string[]>('/api/secured/hoga/suggest', {params})
    }
}
